import React, { useState } from "react";
import emailjs from "emailjs-com";
import { FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";
import "./Contact.css";

function Contact() {
  const [xp, setXp] = useState(0);
  const [message, setMessage] = useState("");
  const [level, setLevel] = useState("Novice Communicator");
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const levels = [
    { xp: 0, title: "Novice Communicator" },
    { xp: 200, title: "Casual Conversationalist" },
    { xp: 500, title: "Dedicated Networker" },
    { xp: 1000, title: "Master Communicator" }
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "message") setMessage(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const earnedXP = message.length > 50 ? 100 : 50;
    const newXP = xp + earnedXP;
    setXp(newXP);
    const newLevel = levels.find((lvl) => newXP >= lvl.xp)?.title || level;
    setLevel(newLevel);

    emailjs
      .send(
        "service_xoouu6f", // Replace with EmailJS service ID
        "template_vv4f0rm", // Replace with EmailJS template ID
        formData,
        "o7DfHU6gzbkZKgubX" // Replace with EmailJS public key
      )
      .then(
        (response) => {
          alert(`🎉 Message sent! You earned ${earnedXP} XP! New Level: ${newLevel}`);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
  };

  return (
    <div className="contact-container">
      <h1>📬 Contact Me</h1>

      {/* XP Progress */}
      <div className="xp-bar-container">
        <p>🎮 XP Gained: {xp} / 1000</p>
        <div className="xp-bar">
          <div className="xp-fill" style={{ width: `${(xp / 1000) * 100}%` }}></div>
        </div>
        <p>🏆 Current Level: {level}</p>
      </div>

      {/* Contact Form */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
        <textarea
          name="message"
          placeholder="Your Message (More details = More XP!)"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit">Send Message 🚀</button>
      </form>

    {/* Social Media Links */}
    <div className="social-media">
    <h3>🔗 Connect with Me</h3>
    <div className="social-icons">
      <a href="https://www.linkedin.com/in/abinash-mishra-3912b618b/" target="_blank" rel="noopener noreferrer">
        <FaLinkedin className="social-icon linkedin" />
      </a>
      <a href="https://github.com/ABBU2712" target="_blank" rel="noopener noreferrer">
        <FaGithub className="social-icon github" />
      </a>
      <a href="https://www.instagram.com/bojack_horseman2712?igsh=ODlveGVlaDIxeWc1" target="_blank" rel="noopener noreferrer">
        <FaInstagram className="social-icon instagram" />
      </a>
    </div>
  </div>
  </div>
  );
}

export default Contact;
